<template>
  <div class="form-check" v-if="valueModel">
    <input class="form-check-input" type="checkbox" :id="'checkbox-'+$.uid" v-model="valueModel.value" :required="props.required" role="button"/>
    <label class="form-check-label" :for="'checkbox-'+$.uid" role="button">{{ props.label }}</label>
    <div class="invalid-feedback">{{ errorMessage }}</div>
  </div>
</template>
<script setup lang="ts">
  import { useField } from 'vee-validate';
  import { computed } from 'vue';

  const model = defineModel<boolean>({ default: false, required: false });

  const props = withDefaults(defineProps<{
    valueKey?: AllTypeKeys;
    label?: string;
    required?: boolean;
  }>(), {
    label: '',
    required: false,
  });

  const { value, errorMessage } = props.valueKey !== undefined ? useField<string>(() => props.valueKey!) : {};

  const valueModel = computed(() => {
    if(props.valueKey) return value;
    else if(model.value !== undefined) return model;
    else return undefined;
  })
</script>
